<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="维修记录问题">
          <el-input placeholder="请输入维修记录问题" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加维修记录</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <!-- <el-table-column prop="name" label="维修记录名称"></el-table-column> -->
            <el-table-column prop="yz_name" label="提交人"></el-table-column>
            <el-table-column prop="contact_tel" label="电话"></el-table-column>
            <el-table-column prop="intro" label="问题"></el-table-column>
            <el-table-column label="是否是内部提交">
              <template #default="{ row }">
                <span>{{ row.is_nb === 1 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="class_name" label="分类"></el-table-column>
            <el-table-column prop="depart_name" label="负责人"></el-table-column>
            <el-table-column prop="repair_name" label="维修人员"></el-table-column>
            <el-table-column prop="status" label="维修状态">
              <template #default="{ row }">
                <span :class="'status-tag status-' + row.status">
                  {{ formatStatus(row.status) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="jd_time" label="接单时间"></el-table-column>
            <el-table-column prop="wxz_time" label="维修中时间"></el-table-column>
            <!-- <el-table-column prop="willwc_time" label="预计完成时间"></el-table-column> -->
            <el-table-column prop="wc_time" label="完成时间"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="commentClick(scope.row)" type="text" size="small" v-if="scope.row.maintenance_record_comment_id > 0">查看评价</el-button>
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :maintenance_record_id="maintenance_record_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Comment :open_add="open_comment" :maintenance_record_id="maintenance_record_id"  v-if="open_comment"   @close="closeComment"></Comment>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Maintenance_recordApi from '@/api/maintenance_record.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Comment from './part/comment.vue';

  export default {
    components: {
      Add,
      Edit,
      Comment
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        open_comment:false,
        maintenance_record_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      formatStatus(statusCode) {
        const statusMap = {
          1: '待处理',
          2: '已派单',
          3: '维修中',
          4: '已完成',
          5: '已取消'
        };
        return statusMap[statusCode] || '未知状态';
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//维修记录标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeComment(e){
      this.open_comment=false;
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Maintenance_recordApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.maintenance_record_id = row.maintenance_record_id;
        this.open_edit = true
      },

      /*查看评价*/
      commentClick(row) {
        this.maintenance_record_id = row.maintenance_record_id;
        this.open_comment = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Maintenance_recordApi.del(
              {
                maintenance_record_id: row.maintenance_record_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style>
.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: white;
}
.status-1 {
  background-color: #909399; /* 待处理 - 灰色 */
}
.status-2 {
  background-color: #606266; /* 已派单 - 深灰 */
}
.status-3 {
  background-color: #409EFF; /* 维修中 - 蓝色 */
}
.status-4 {
  background-color: #67C23A; /* 已完成 - 绿色 */
}
.status-5 {
  background-color: #F56C6C; /* 已取消 - 红色 */
}
</style>



// WEBPACK FOOTER //
// src/views/plus/maintenance_record/index/index.vue